import React from 'react'
import './styles.css'
const LockScreen = () => {

    return (
        <>
            <div className="overlay">
                <div className='spinner'>
                </div>
            </div>
        </>
    )
}

export default LockScreen